export default "__VITE_ASSET__BprQrWYK__"